
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import u from '@/utility/utility';
import DeliveryInfo from './components/DeliveryInfo.vue';
import ListOrder from './components/ListOrder.vue';
import { Order } from '@/models/order';
import { Customer } from '@/models/customer';
import { PaymentRequestModel } from '@/models/payment-request';
import authService from '@/services/auth-services';
import orderService from '@/services/order-service';
import paymentRequestServices from '@/services/payment-request-services';

@Component({
    components: {
        Loading,
        'delivery-info': DeliveryInfo,
        'list-order': ListOrder
    }
})
export default class DetailPaymentRequest extends Vue {
    private paymentRequest: PaymentRequestModel = new PaymentRequestModel();
    private listOrders: any[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;

    get requestId() {
        return this.$route.params.id;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get totalChoose() {
        return this.listOrders.length;
    }

    get totalAmount() {
        return this.listOrders.reduce((total: number, order: Order) => {
            return total + (order.totalAmountVND || 0);
        }, 0);
    }

    @Watch('requestId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.requestId) {
            this.loadData();
        }
    }

    private getStatus(value: any) {
        return DATA.orderStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private async loadData() {
        if (this.requestId) {
            const result = await paymentRequestServices.getPaymentRequestByID(this.requestId);
            this.listOrders = [];
            if (result && result.status === 200 && (result.data.data.length > 0 || result.data.data.ID > 0)) {
                const ret = result.data.data;
                this.paymentRequest = new PaymentRequestModel();
                this.paymentRequest.id = ret.ID;
                this.paymentRequest.status = ret.Status;
                this.paymentRequest.statusDetail = DATA.requestPaymentStatus.find(x => x.value === ret.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                this.paymentRequest.totalAmount = ret.TotalAmount;
                this.paymentRequest.totalPayment = ret.TotalPayment;
                this.paymentRequest.totalOrder = ret.TotalOrder;
                this.paymentRequest.feeShip = ret.FeeShip;
                this.paymentRequest.receiverName = ret.ReceiverName;
                this.paymentRequest.receiverPhone = ret.ReceiverPhone;
                this.paymentRequest.receiverAddress = ret.ReceiverAddress;
                this.paymentRequest.shippingMethod = ret.ShippingMethod;
                this.paymentRequest.note = ret.Note;
                this.paymentRequest.customerNote = ret.CustomerNote;
                const tmpListOrder: Order[] = [];
                for (const item of ret.Orders) {
                    const order: any = {};
                    order.id = item.ID;
                    order.transactionCode = item.TransactionCode;
                    order.packageCode = item.PackageCode;
                    order.orderID = item.OrderID;
                    order.requestID = item.RequestID;
                    order.uID = item.UID;
                    order.orderType = item.OrderType;
                    order.numberOfPack = item.NumberOfPack;
                    order.weight = item.Weight;
                    order.weightByVolume = item.WeightByVolume;
                    order.volume = item.Volume;
                    order.orderNote = item.OrderNote;
                    order.feeShipType = item.FeeShipType;
                    order.priceType = item.PriceType;
                    tmpListOrder.push(order);
                }
                this.listOrders = tmpListOrder;
            }
        }
    }
}
